import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const DeleteButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Delete" id="delete-tooltip" placement="top">
      <ButtonComponent type="button" color="danger mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="Delete" height="18" />
        &nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

DeleteButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default DeleteButtonComponent
